interface Flavor {
    val clientName: String
    val adminClientName: String
    val clientUrl: String
    val serverHttps: Boolean
    val environmentName: String
    val serverUrl: String
    val serviceServerUrl: String
    val serverPort: Int?
    val serviceServerPort: Int?
    val databaseConnectionString: String
    val serverBusConnectionString: String
    val enpTerminalServerHost: String
    val enpServiceServerHost: String
    val token: String
    val serviceApiKey: String
    val hubspotAccessToken: String?
    val hubspotClientSecret: String?
    val inboundServiceApiKey: String?
    val portalUrl: String
    val coalitionUrl: String
    val isDebug: Boolean
    val alternateAdminLink: String
    val alternateAdminTitle: String
    val testHarnessUrl: String
    val logSources: List<LogSource>
    val cartoApiKey: String get() = "cb1_50f1_1_45f2312319d77123309acf67"
}

data class LogSource(
    val label: String,
    val containerAppName: String,
    val workspaceId: String,
)